'use client';

import { KeyboardArrowLeft } from '../../icons';
import { styled } from '../../styles';
import { IconButtonLink } from '../IconButtonLink';

import { HeaderSize } from './types';

export const HeaderContainer = styled('div', {
  shouldForwardProp: (prop) => prop !== 'size',
})<{ size?: HeaderSize }>(({ theme, size }) => ({
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(4),
  padding: size === 'medium' ? theme.spacing(4, 3) : theme.spacing(6, 3),
  borderBottom: `1px solid ${theme.palette.divider}`,
  background: theme.palette.surface2,
}));

export const HeaderBackButton = styled(IconButtonLink)(({ theme }) => ({
  width: 32,
  height: 32,
  padding: theme.spacing(0),
}));

export const HeaderBackIcon = styled(KeyboardArrowLeft)(() => ({
  width: 32,
  height: 32,
}));

export const HeaderBackEmpty = styled.div(() => ({
  width: 32,
  height: 32,
}));
